import { createStore } from 'vuex'

export default createStore({
  state: {
    sidebarActive: false,
    notifications: [],
    notifications_i: 0
  },
  getters: {
    isSidebarOpen({sidebarActive}) {
      return sidebarActive
    },
    getNotifications({notifications}) {
      return notifications
    }
  },
  mutations: {
    toggleSidebar(state, doOpen) {
      state.sidebarActive = doOpen != null && typeof doOpen === 'boolean' ? doOpen : !state.sidebarActive
      if (state.sidebarActive) {
        document.body.classList.add('is-sidebar-open')
      } else {
        document.body.classList.remove('is-sidebar-open')
      }
    },
  },
  actions: {
    async pushItem({state}, {message, options}) {
      if (!message || message.length < 1) {
        return
      }

      const id = options?.id || state.notifications_i
      const existingIndex = state.notifications.findIndex(n=> n.id === id)
      const noti = {
        id,
        message,
        createdAt: Date.now()
      }

      if (existingIndex > -1) {
        state.notifications = state.notifications.filter(n=> n.id !== id)
        await new Promise((res)=> setTimeout(res, 0))
      }

      state.notifications.push(noti)

      state.notifications_i++
    },
    removeItem({state}, id) {
      state.notifications = state.notifications.filter(n=> n.id !== id)
    },
  },
  modules: {
  }
})
